export default __webpack_public_path__ + "static/media/websiteMes.cbe00933.png";